import Shipments from "./Shipments";

export default Shipments;
